import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { pageLoader } from "../../../Redux/actions/user-actions";
import clapImage from "../../../assets/images/img_008_great.png";
import {
  authApi,
  getAuthorizationHeader,
} from "../../../api-calls/user-requests";
import CloseIcon from "@mui/icons-material/Close";
import { Typography, Divider } from "@mui/material";

import {
  Button,
  Grid,
  Stack,
  Card,
  CardContent,
  CardActions,
  Chip,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import {
  MY_SUBS,
  MY_SUBSCRIPTION,
  MY_SUBS_AVAIL,
  PAYMENT_SUCCESS,
  REFERAL_SUBSCRIPTION,
  RENEW_SUBS,
  SUBSCRIPTION_LIST,
  UPDATE_REFERALS,
} from "../../../api-calls/api-urls";
import { useDispatch, useSelector } from "react-redux";
import { getLanguagedataFunction } from "../../../utilities/language";
import { generateColor } from "../../../utilities/commonFunctions";
import moment from "moment";
import ConfirmationModal from "../../Home/Subscription/ConfirmationModal";
import loadRazorpayScript from "../../../utilities/loadRazorpay";
import { toast } from "react-toastify";

const RegisteredSuccessfully = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const rootRef = React.useRef(null);
  const [page, setPage] = useState(true);
  const [oneSubsc, setOneSubsc] = useState();
  const [modalToggle, setModalToggle] = useState(false);
  const [modalToggle1, setModalToggle1] = useState(false);
  const [plans, setPlans] = useState();
  const [selectedValue, setSelectedValue] = useState(null);
  // eslint-disable-next-line unused-imports/no-unused-vars
  const [discount, setDiscount] = useState("");
  // eslint-disable-next-line unused-imports/no-unused-vars
  const userData = JSON.parse(sessionStorage.getItem("userInfo"));
  // eslint-disable-next-line unused-imports/no-unused-vars
  const params = useParams();
  const [selectedPlan, setSelectedPlan] = useState({});
  // eslint-disable-next-line unused-imports/no-unused-vars
  const [selectedDuration, setSelectedDuration] = useState({});
  const [billingCycle, setBillingCycle] = useState(null);

  useEffect(() => {
    const path = window.location.pathname;
    if (path.includes("/select-subscription")) {
      setPage(false);
    } else if (path.includes("/referal-subscription")) {
      setPage(false);
    } else if (path.includes("/upgrade-plan")) {
      setPage(false);
      const path = window.location.pathname.split("/");
      getCustomerSubscription(path[path?.length - 1]);
    }
  }, []);

  const getCustomerSubscription = async (id) => {
    try {
      const { data } = await authApi.get(`${MY_SUBS}/get-one/${id}`, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      console.log(data);
      setOneSubsc(data);
    } catch (error) {
      console.log(error);
    }
  };

  const closeModal1 = () => {
    setModalToggle1(false);
    navigate("/subscriptions");
  };

  const getPlansDetails = async () => {
    try {
      const { data } = await authApi.get(SUBSCRIPTION_LIST, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      setPlans(data);
      if (data && data?.length > 0 && data[0].durations) {
        setSelectedPlan(data[0]);
        setSelectedValue(data[0].durations[0]._id);
        localStorage.setItem("selctedplan_id", data[0].durations[0]._id);
        setBillingCycle(data[0].durations[0].duration);
      }
    } catch (error) {
      console.log(error);
      toast.error("Failed to load subscription plans.");
    }
  };

  const ln = useSelector((state) => state.allUsers.language_json);

  useEffect(() => {
    getLanguagedataFunction(dispatch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!ln]);

  useEffect(() => {
    if (!plans) {
      getPlansDetails();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!plans]);

  // eslint-disable-next-line unused-imports/no-unused-vars
  const handleChange = (value) => {
    localStorage.setItem("selctedplan_id", value);

    setSelectedValue(value);
  };
  function closeModal() {
    setModalToggle(false);
  }

  const posibleUpgrade = (member, duration) => {
    const cur_point = oneSubsc?.no_team_members * oneSubsc?.duration;
    const new_point = member * duration;
    if (cur_point < new_point) {
      return true;
    } else {
      return false;
    }
  };

  const getSubsription = async () => {
    var result = {};
    await authApi
      .get(MY_SUBS_AVAIL, {
        headers: { Authorization: getAuthorizationHeader() },
      })
      .then(function (res) {
        //dispatch(SaveAvailableSubc(res.data));
        result = res.data[res.data?.length - 1];
      });
    return result;
  };
  const sucessApiCall = async () => {
    try {
      const userEntry = {
        subscriptionid: selectedPlan._id,
        durationid: selectedValue,
      };
      const { data } = await authApi.post(MY_SUBSCRIPTION, userEntry, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      if (
        data.data &&
        data.data.order_items &&
        data.data.order_items.length > 0
      ) {
        const userEntry2 = {
          userid: data.data.user_id,
          orderid: data.data._id,
        };

        // eslint-disable-next-line unused-imports/no-unused-vars
        const data2 = await authApi.post(PAYMENT_SUCCESS, userEntry2, {
          headers: { Authorization: getAuthorizationHeader() },
        });
      }
      navigate("/my-team/create-team");
    } catch (error) {
      toast.error(error.response?.data?.message || "Something went wrong");
      console.log(error);
    }
  };
  const basePrice = discount || 0;
  const gstPercent = 18;
  const gstAmount = (basePrice * gstPercent) / 100;
  const priceWithGST = Number(basePrice) + Number(gstAmount);
  // eslint-disable-next-line unused-imports/no-unused-vars
  const total = Math.max(priceWithGST, 0);

  // razor payment popup

  function isFreeDurationInPackages(durationId) {
    console.log(plans, durationId);

    for (const pkg of plans) {
      for (const duration of pkg.durations) {
        if (duration._id === durationId) {
          return Number(duration.price) === 0;
        }
      }
    }
    return false; // Not found or not free
  }
  const handleClick = async (item, activeDurationId) => {
    console.log("item:", item);
    const pathname = window.location.pathname;
    const isUpgrade = pathname.includes("upgrade-plan");

    if (!activeDurationId) {
      return toast.warning("Please select a billing cycle.");
    }

    if (
      pathname.includes("register-success") &&
      !isFreeDurationInPackages(activeDurationId)
    ) {
      return navigate("/order_summary");
    }

    if (
      pathname.includes("/select-subscription") &&
      !isFreeDurationInPackages(activeDurationId)
    ) {
      return navigate(`/order_summary_forall/${activeDurationId}`);
    }

    if (activeDurationId && isFreeDurationInPackages(activeDurationId)) {
      console.log("Free duration selected, proceeding without payment.");
      sucessApiCall();
    }
    if (pathname.includes("/referal-subscription")) {
      const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      const referal_data = JSON.parse(sessionStorage.getItem("referal_data"));

      const no_of_days = Math.floor(
        referal_data.referal_points / item.noOfTeamMembers,
      );

      const userEntry = {
        subscription_id: item._id,
        user_id: userInfo._id,
        referal_id: referal_data.referal_id,
        no_of_days,
      };

      // eslint-disable-next-line unused-imports/no-unused-vars
      const { data } = await authApi.post(REFERAL_SUBSCRIPTION, userEntry, {
        headers: { Authorization: getAuthorizationHeader() },
      });

      MakePointsNull(referal_data.referal_id);
      sessionStorage.removeItem("referal_data");

      return navigate("/subscriptions");
    }

    // ✅ Only run below code for /upgrade-plan
    if (isUpgrade) {
      try {
        // This charge is always a prorated delta (credit for unused days on
        // the current plan), never the plan's listed price, so it can't map
        // onto a fixed-price Razorpay recurring Plan — this path stays on
        // the one-time Orders API intentionally. The *next* regular renewal
        // (via /subscriptions or /order_summary) goes through the recurring
        // flow once the upgraded plan/duration has a razorpay_plan_id.
        // Compute the charge amount from the selected duration, applying
        // an upgrade discount (credit for unused days on the current plan)
        const selectedDur = item.durations?.find(
          (d) => d._id === activeDurationId,
        );
        const rawPrice = parseFloat(formatPrice(selectedDur?.price) || 0);
        const baseChargeAmount = oneSubsc
          ? parseFloat(
              getDiscountAmount(
                item.noOfTeamMembers,
                selectedDur?.days,
                rawPrice,
              ),
            )
          : rawPrice;
        const res = await loadRazorpayScript(
          "https://checkout.razorpay.com/v1/checkout.js",
        );

        if (!res) {
          alert("Razorpay SDK failed to load. Are you online?");
          return;
        }

        // Create the order first: the server works out the prorated price,
        // prices the checkout from it, and confirms the payment against it.
        const customerSubId = pathname.split("/").pop();
        const { data: selected } = await authApi.post(
          MY_SUBSCRIPTION,
          {
            subscriptionid: item._id,
            durationid: activeDurationId,
            customer_sub_id: customerSubId,
            team_id: sessionStorage.getItem("team_id") || undefined,
          },
          { headers: { Authorization: getAuthorizationHeader() } },
        );
        const dbOrder = selected?.data;
        if (!dbOrder?._id) {
          toast.error("Unable to create order. Please try again.");
          return;
        }

        const chargeAmount =
          dbOrder.order_payable ??
          Number((baseChargeAmount * 1.18).toFixed(2));

        if (!chargeAmount || isNaN(chargeAmount) || chargeAmount <= 0) {
          toast.error("Upgrade amount must be greater than zero.");
          return;
        }

        const { data } = await authApi.post(`/my-subscriptions/create-order`, {
          amount: chargeAmount,
          currency: "INR",
          receipt: `receipt_${dbOrder._id}`,
          order_id: dbOrder._id,
        });

        let paymentHandled = false;

        const options = {
          key: process.env.REACT_APP_RAZORPAY_KEY_ID,
          amount: data.order.amount,
          currency: data.order.currency,
          name: "Team Player App",
          description: "Payment for subscription",
          order_id: data.order.id,
          handler: async (response) => {
            if (paymentHandled) {
              return;
            }
            paymentHandled = true;
            const verifyRes = await authApi.post(
              `/my-subscriptions/verify-order`,
              {
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
              },
            );

            if (verifyRes.data.success) {
              dispatch(pageLoader(true));

              if (dbOrder.order_items && dbOrder.order_items.length > 0) {
                const userEntry2 = {
                  userid: dbOrder.user_id,
                  orderid: dbOrder._id,
                  customer_sub_id: customerSubId,
                  type: "upgrade",
                  payment_details: {
                    razorpay_order_id: response.razorpay_order_id,
                    razorpay_payment_id: response.razorpay_payment_id,
                    razorpay_signature: response.razorpay_signature,
                  },
                };

                const data2 = await authApi.post(PAYMENT_SUCCESS, userEntry2, {
                  headers: { Authorization: getAuthorizationHeader() },
                });

                const availsubs = await getSubsription();
                const team_id = sessionStorage.getItem("team_id");

                if (data2.data && availsubs && team_id) {
                  const userEntry3 = {
                    team_id,
                    avail: availsubs,
                    type: "upgrade",
                  };

                  // eslint-disable-next-line unused-imports/no-unused-vars
                  const data3 = await authApi.post(RENEW_SUBS, userEntry3, {
                    headers: { Authorization: getAuthorizationHeader() },
                  });
                  setModalToggle1(true);

                  sessionStorage.removeItem("team_id");
                }
              }
            } else {
              alert("Payment Verification Failed.");
            }
          },
          theme: {
            color: "#528FF0",
          },
          modal: {
            ondismiss: () => {
              if (!paymentHandled) {
                paymentHandled = true;
                toast.error("Payment Cancelled!");
              }
            },
          },
        };

        const rzp = new window.Razorpay(options);

        // 🔴 Handle payment failure explicitly
        rzp.on("payment.failed", function (response) {
          if (!paymentHandled) {
            paymentHandled = true;
            console.error("Payment failed:", response);
            alert("Payment Failed!\nReason: " + response.error.description);
          }
        });

        rzp.open();
      } catch (error) {
        console.error("Payment Error:", error);
        toast.error(
          error?.response?.data?.message ||
            error?.response?.data?.error ||
            error?.message ||
            "Payment failed. Please try again.",
        );
      }
      if (page) {
        navigate("/payment_success");
      }

      return;
    }

    // ❌ If not upgrade, don't proceed with any post request
    console.warn("Unhandled path, no subscription logic executed.");
  };

  const getDiscountAmount = (member, duration, price) => {
    const rawPriceVal = oneSubsc?.duration_details?.price;
    const priceNum =
      rawPriceVal?.$numberDecimal != null
        ? parseFloat(rawPriceVal.$numberDecimal)
        : parseFloat(rawPriceVal) || 0;
    const cure_Per = priceNum / (oneSubsc?.duration || 1);
    const expiryDate = moment(oneSubsc?.end_date);
    const today = moment();
    const remainingDays = Math.max(0, expiryDate.diff(today, "days"));
    const discount_amt = remainingDays * cure_Per;
    const amount = price - discount_amt;
    return isNaN(amount) ? price.toFixed(2) : Math.max(0, amount).toFixed(2);
  };

  const formatPrice = (price) => {
    if (price === null || price === undefined) return "0";
    if (typeof price === "object" && price.$numberDecimal !== undefined)
      return price.$numberDecimal;
    return String(price);
  };

  const getDurationForCycle = (plan) =>
    plan.durations?.find((d) => d.duration === billingCycle);

  const isCurrentPlan = (plan) =>
    oneSubsc && plan._id === oneSubsc.subscription_id;

  const billingCycles = plans
    ? [
        ...new Set(
          plans.flatMap((p) => p.durations?.map((d) => d.duration) ?? []),
        ),
      ]
    : [];

  const MakePointsNull = (id) => {
    try {
      // eslint-disable-next-line unused-imports/no-unused-vars
      const { data } = authApi.put(
        `${UPDATE_REFERALS}/${id}`,
        {},
        {
          headers: { Authorization: getAuthorizationHeader() },
        },
      );
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Box>
      {ln ? (
        <Box sx={{ minHeight: "100vh", py: 3 }}>
          {/* <!-- start page title --> */}
          {page ? (
            <Box sx={{ mt: 0, mb: 6 }}>
              <Box sx={{ width: "100%" }}>
                <Box
                  sx={{ textAlign: "center", backgroundColor: "transparent" }}
                >
                  <>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        mb: 4,
                      }}
                    >
                      <Box sx={{ mb: 2 }}>
                        <img
                          src={clapImage}
                          alt=""
                          style={{ width: "120px", height: "auto" }}
                        />
                      </Box>
                      <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
                        {ln.registered_successfully}
                      </Typography>
                      <Typography
                        variant="body1"
                        color="text.secondary"
                        sx={{ mb: 2 }}
                      >
                        {ln.account_created_successfully}
                      </Typography>
                      <Button
                        variant="text"
                        onClick={() => setModalToggle(true)}
                        sx={{ textTransform: "none", fontWeight: 600 }}
                      >
                        {ln.demo_video}
                      </Button>
                    </Box>
                  </>

                  {/* <!-- Default Modals --> */}
                  <Modal
                    open={modalToggle}
                    onClose={() => closeModal()}
                    aria-labelledby="server-modal-title"
                    data-testid="register_modal"
                    aria-describedby="server-modal-description"
                    sx={{
                      display: "flex",
                      height: 300,
                      marginTop: 10,
                      justifyContent: "center",
                    }}
                    container={() => rootRef.current}
                  >
                    <Box
                      sx={{
                        position: "relative",
                        bgcolor: "background.paper",
                        borderRadius: 1,
                        boxShadow: (theme) => theme.shadows[5],
                      }}
                      style={{ width: "70%", height: "575px" }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                        }}
                      >
                        <Button
                          size="small"
                          onClick={() => closeModal()}
                          variant="text"
                        >
                          <CloseIcon />
                        </Button>
                      </div>
                      <Box sx={{ backgroundColor: "transparent" }}>
                        <Box sx={{ backgroundColor: "transparent" }}>
                          <Box sx={{ backgroundColor: "transparent" }}>
                            <video controls autoPlay width="100%" height="">
                              <source
                                type="video/mp4"
                                src="https://endtest-videos.s3-us-west-2.amazonaws.com/documentation/endtest_data_driven_testing_csv.mp4"
                              />
                            </video>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </Modal>

                  <Box
                    id="myModal"
                    tabIndex="-1"
                    aria-labelledby="myModalLabel"
                    aria-hidden="true"
                    sx={{ display: "none" }}
                  >
                    {/* <!-- /.modal-dialog --> */}
                  </Box>
                  {/* <!-- /.modal --> */}
                </Box>
              </Box>
            </Box>
          ) : null}
          {/* <!-- end page title --> */}

          <Box sx={{ mt: 4 }}>
            <Typography
              variant="h5"
              sx={{ mb: 3, fontWeight: 700, textAlign: "center" }}
            >
              {ln.select_your_package}
            </Typography>

            {/* Billing cycle toggle */}
            {billingCycles.length > 1 && (
              <Box sx={{ display: "flex", justifyContent: "center", mb: 4 }}>
                <Box
                  sx={{
                    display: "inline-flex",
                    bgcolor: "#f0f4f8",
                    borderRadius: "10px",
                    p: "4px",
                    gap: "4px",
                  }}
                >
                  {billingCycles.map((cycle) => (
                    <Button
                      key={cycle}
                      disableElevation
                      variant={billingCycle === cycle ? "contained" : "text"}
                      onClick={() => setBillingCycle(cycle)}
                      sx={{
                        borderRadius: "7px",
                        textTransform: "capitalize",
                        fontWeight: 600,
                        fontSize: "14px",
                        px: 3,
                        py: 0.75,
                        minWidth: "110px",
                        bgcolor:
                          billingCycle === cycle ? "white" : "transparent",
                        color: billingCycle === cycle ? "#0a1f41" : "#6b778c",
                        boxShadow:
                          billingCycle === cycle
                            ? "0 1px 4px rgba(0,0,0,0.12)"
                            : "none",
                        "&:hover": {
                          bgcolor: billingCycle === cycle ? "white" : "#e8edf2",
                        },
                      }}
                    >
                      {ln[cycle] || cycle}
                    </Button>
                  ))}
                </Box>
              </Box>
            )}

            <Grid container spacing={3} justifyContent="center">
              {plans &&
                plans.map((plan, index) => {
                  const dur = getDurationForCycle(plan);
                  const isCurrent = isCurrentPlan(plan);
                  const canBuy =
                    dur &&
                    (!oneSubsc ||
                      posibleUpgrade(plan.noOfTeamMembers, dur.days));
                  const price = dur ? formatPrice(dur.price) : null;
                  const isFree = price !== null && parseFloat(price) === 0;
                  const accentColor = generateColor(plan.packageName);

                  return (
                    <Grid item xs={12} md={6} lg={4} key={index}>
                      <Card
                        sx={{
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          borderRadius: "14px",
                          border: isCurrent
                            ? `2px solid ${accentColor}`
                            : "1px solid #e8edf2",
                          boxShadow: isCurrent
                            ? `0 0 0 3px ${accentColor}22`
                            : "0 2px 8px rgba(0,0,0,0.06)",
                          position: "relative",
                          overflow: "visible",
                        }}
                      >
                        {isCurrent && (
                          <Box
                            sx={{
                              position: "absolute",
                              top: -13,
                              left: "50%",
                              transform: "translateX(-50%)",
                              bgcolor: accentColor,
                              color: "white",
                              fontSize: "11px",
                              fontWeight: 700,
                              px: 2,
                              py: 0.4,
                              borderRadius: "20px",
                              whiteSpace: "nowrap",
                              letterSpacing: "0.5px",
                              textTransform: "uppercase",
                            }}
                          >
                            Current Plan
                          </Box>
                        )}

                        {/* Card header */}
                        <Box
                          sx={{
                            px: 3,
                            pt: 3,
                            pb: 2,
                            borderBottom: `3px solid ${accentColor}`,
                            bgcolor: `${accentColor}0d`,
                            borderRadius: "14px 14px 0 0",
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: 700,
                              fontSize: "18px",
                              color: "#0a1f41",
                              mb: 1.5,
                            }}
                          >
                            {plan.packageName}
                          </Typography>

                          {/* Price display */}
                          {dur ? (
                            isFree ? (
                              <Chip
                                label="Free"
                                sx={{
                                  bgcolor: "#e6f4ea",
                                  color: "#2e7d32",
                                  fontWeight: 700,
                                  fontSize: "14px",
                                  height: "28px",
                                }}
                              />
                            ) : (
                              <Box>
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "baseline",
                                    gap: 0.5,
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      fontSize: "28px",
                                      fontWeight: 800,
                                      color: "#0a1f41",
                                      lineHeight: 1,
                                    }}
                                  >
                                    ₹{price}
                                  </Typography>
                                  <Typography
                                    sx={{ fontSize: "13px", color: "#6b778c" }}
                                  >
                                    /{ln[dur.duration] || dur.duration}
                                  </Typography>
                                </Box>
                                <Typography
                                  sx={{ fontSize: "11px", color: "#8a96a8", mt: 0.5 }}
                                >
                                  excl. 18% GST
                                </Typography>
                              </Box>
                            )
                          ) : (
                            <Typography
                              sx={{ fontSize: "13px", color: "#8a96a8" }}
                            >
                              Not available for this cycle
                            </Typography>
                          )}
                        </Box>

                        <CardContent sx={{ flexGrow: 1, px: 3, py: 2.5 }}>
                          <Stack spacing={2}>
                            {/* Member count */}
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                bgcolor: "#f8fafc",
                                borderRadius: "8px",
                                px: 2,
                                py: 1.25,
                              }}
                            >
                              <Typography
                                variant="body2"
                                color="text.secondary"
                              >
                                {ln.members_can_add}
                              </Typography>
                              <Typography
                                variant="body2"
                                sx={{ fontWeight: 700, color: "#0a1f41" }}
                              >
                                {ln.upto} {plan.noOfTeamMembers}
                              </Typography>
                            </Box>

                            <Divider />

                            {/* Features */}
                            <Box>
                              <Typography
                                variant="subtitle2"
                                sx={{ mb: 1.25, color: "#0a1f41" }}
                              >
                                {ln.features}
                              </Typography>
                              <Stack spacing={0.75}>
                                {plan.features?.map((feature, fIndex) => (
                                  <Box
                                    key={fIndex}
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 1.25,
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        width: 7,
                                        height: 7,
                                        borderRadius: "50%",
                                        bgcolor: accentColor,
                                        flexShrink: 0,
                                      }}
                                    />
                                    <Typography
                                      variant="body2"
                                      color="text.secondary"
                                    >
                                      {feature.feature}
                                    </Typography>
                                  </Box>
                                ))}
                              </Stack>
                            </Box>
                          </Stack>
                        </CardContent>

                        <CardActions sx={{ p: 3, pt: 0 }}>
                          {isCurrent ? (
                            <Button
                              variant="outlined"
                              fullWidth
                              disabled
                              sx={{
                                borderRadius: "8px",
                                textTransform: "none",
                                fontWeight: 600,
                                borderColor: accentColor,
                                color: accentColor,
                                "&.Mui-disabled": {
                                  borderColor: `${accentColor}88`,
                                  color: `${accentColor}88`,
                                },
                              }}
                            >
                              Current Plan
                            </Button>
                          ) : (
                            <Button
                              variant="contained"
                              fullWidth
                              disableElevation
                              disabled={!canBuy || !dur}
                              onClick={() => {
                                setSelectedPlan(plan);
                                setSelectedValue(dur._id);
                                handleClick(plan, dur._id);
                              }}
                              sx={{
                                borderRadius: "8px",
                                textTransform: "none",
                                fontWeight: 600,
                                fontSize: "15px",
                                py: 1.25,
                                bgcolor: accentColor,
                                "&:hover": {
                                  bgcolor: accentColor,
                                  filter: "brightness(0.9)",
                                },
                                "&.Mui-disabled": {
                                  bgcolor: "#e0e0e0",
                                  color: "#9e9e9e",
                                },
                              }}
                            >
                              {!canBuy && oneSubsc
                                ? "Not Available"
                                : ln.but_this}
                            </Button>
                          )}
                        </CardActions>
                      </Card>
                    </Grid>
                  );
                })}
            </Grid>
          </Box>
        </Box>
      ) : null}

      {modalToggle1 && (
        <ConfirmationModal closeModal={closeModal1} from="upgrade" />
      )}
    </Box>
  );
};

export default RegisteredSuccessfully;
